export class Garantias {
     id:{
        numId: string;
        fecPrestamo: Date;
        fecVencimiento: Date;
     }
    nomSocio: string;
    apeSocio: string;
    valCapital:number;
    valTasaInteres:number;
    cfValSaldo: number;
    numDiasMora: number;
}
